export default __webpack_public_path__ + "static/media/wordpressPics.cdbf99a8.png";